import { Message } from 'element-ui'
function judgmentTime(date, startTime, endTime, msg, next) {
    var curDate = new Date();
    var currentDate = `${curDate.getFullYear()}-${(curDate.getMonth()+1)}-${curDate.getDate()}-${(curDate.getHours()*60+curDate.getMinutes())}`;
    let currentArr = currentDate.split("-").map(item => {
        return parseInt(item)
    });
    let itemArr = date.split("-").concat(parseInt(startTime.split(":")[0]*60) + parseInt(startTime.split(":")[1])).map(item => {
        return parseInt(item)
    });
    let resultEndTime = parseInt(endTime.split(":")[0]*60) + parseInt(endTime.split(":")[1]);
    for(let i = 0; i < itemArr.length; i++) {
        if(itemArr[i] != currentArr[i]) {
            if(i == 0 || i == 1 || i == 2) {
                if(itemArr[i] > currentArr[i]) {
                    Message({
                        message: msg.startContent,
                        type: 'warning'
                    });
                } else {
                    Message({
                        message: msg.endContent,
                        type: 'warning'
                    });
                }
                return;
            } else if(i == 3) {
                if(itemArr[i] - currentArr[i] > 10) {
                    Message({
                        message: msg.startContent,
                        type: 'warning'
                    });
                } else if(currentArr[i] > resultEndTime) {
                    Message({
                        message: msg.endContent,
                        type: 'warning'
                    });
                } else {
                    next(); 
                }
                return;
            }
        }
    }
};
export { judgmentTime };


// WEBPACK FOOTER //
// ./src/utils.js